import { Phone, MessageCircle } from "lucide-react";

// Two stacked floating action buttons on the public site:
//   • WhatsApp (green)  → opens wa.me chat with a precomposed message
//   • Phone (navy blue) → tel: link for direct calls
// Both use the same business number: +39 0965 181 7260
const WA_NUMBER = "390965181 7260".replace(/\s/g, ""); // 3909651817260
const TEL_NUMBER = "+3909651817260";
const WA_MESSAGE = "Ciao B&B Emmanuel, vorrei avere informazioni sul vostro b&b.";

const PhoneFab = () => {
  const waHref = `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(WA_MESSAGE)}`;
  return (
    <>
      <a
        href={waHref}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="whatsapp-fab"
        aria-label="Scrivici su WhatsApp"
        title="Scrivici su WhatsApp"
        className="fixed bottom-44 right-5 z-[9999] w-16 h-16 rounded-full bg-[#25D366] hover:bg-[#1FBA56] text-white shadow-2xl flex items-center justify-center transition-all hover:scale-105"
      >
        <MessageCircle className="w-7 h-7" />
      </a>
      <a
        href={`tel:${TEL_NUMBER}`}
        data-testid="phone-fab"
        aria-label="Chiama il B&B Emmanuel"
        title="Chiama il B&B Emmanuel"
        className="fixed bottom-24 right-5 z-[9999] w-16 h-16 rounded-full bg-[#1E3A5F] hover:bg-[#152A45] text-white shadow-2xl flex items-center justify-center transition-all hover:scale-105"
      >
        <Phone className="w-7 h-7" />
      </a>
    </>
  );
};

export default PhoneFab;
